class ProductOverlay extends HTMLElement {
  constructor() {
    super();

    this.trigger = this.querySelector(".js-trigger");
    this.overlay = this.querySelector(".js-overlay");

    this.addListener();
  }

  addListener() {
    this.trigger.addEventListener("click", () => this.toggleOverlay());
  }

  toggleOverlay() {
    this.overlay.classList.toggle("article-product-grid__overlay--active");
  }
}

customElements.define("product-overlay", ProductOverlay);